import api from '../../../../api/client'

export async function getEmployees(params = {}, config = {}) {
  const res = await api.get('/payroll/employees', { params, ...config })
  return res.data
}

export async function getEmployeeDetail(id) {
  const res = await api.get(`/payroll/employees/${id}`)
  return res.data
}

export async function createEmployee(data) {
  const res = await api.post('/payroll/employees', data)
  return res.data
}

export async function updateEmployee(id, data) {
  const res = await api.put(`/payroll/employees/${id}`, data)
  return res.data
}

export async function deleteEmployee(id) {
  const res = await api.delete(`/payroll/employees/${id}`)
  return res.data
}

export async function archiveEmployee(id, archive) {
  const res = await api.patch(`/payroll/employees/${id}/archive`, null, {
    params: { archive },
  })
  return res.data
}
